import { createContext, useContext } from "react";
import type { ISeriesApi, LineData, OhlcData, Time } from "lightweight-charts";

import { type Bindable, emptyBindable } from "@package/react/bindable";

export type CandleData = OhlcData<Time> & {
  gap: boolean;
  filtered?: boolean;
  original?: OhlcData<Time>;
};

export type PriceLineSeries = ISeriesApi<"Custom", Time, CandleData> | ISeriesApi<"Line", Time, LineData>;

const CandleDataContext = createContext<CandleData[]>([]);
export const CandleDataProvider = CandleDataContext.Provider;
export const useCandleData = () => useContext(CandleDataContext);

const PriceLineSeriesContext = createContext<Bindable<PriceLineSeries>>(emptyBindable());
export const PriceLineSeriesProvider = PriceLineSeriesContext.Provider;
export const usePriceLineSeries = () => useContext(PriceLineSeriesContext);
